import { ContentBody } from "@app/components/core/ContentBody/ContentBody"
import { ContentHeader } from "@app/components/core/ContentHeader/ContentHeader"
import { useCustomNavigation } from "@app/components/navigation/NavigationHandler"
import Page from "@app/components/pageTypes/Page/Page"
import { Redirect } from "@app/components/routing/Redirect"
import { appStore } from "@app/store/store"
import { useSelector } from "@tecreation/js-state-react"

export function FunnelSelection() {
	const relation = useSelector(state => state.core.relation)
	const normalToken = appStore.get("settings").funnelTokens.website
	const htgToken = appStore.get("settings").funnelTokens.htg
	const { replace } = useCustomNavigation()

	if (relation && relation.var1 != "true") {
		return <Redirect to="/login" replace />
	}
	return (
		<Page>
			<ContentHeader>Funnel Selection</ContentHeader>
			<ContentBody className="h-100">
				<div className="flex flex-center h-100" style={{ gap: "80px" }}>
					{normalToken && (
						<div
							className="p-8 boxShadow clickable color-bg-secondary color-fg-white f0"
							onClick={() => {
								appStore.set(state => ({
									settings: {
										...state.settings,
										funnelToken: normalToken,
									},
								}))
								// connectorApiSlice.utils.reset()
								replace("/")
							}}
						>
							Normal
						</div>
					)}

					{htgToken && (
						<div
							className="p-8 boxShadow clickable color-bg-secondary color-fg-white f0"
							onClick={() => {
								appStore.set(state => ({
									settings: {
										...state.settings,
										funnelToken: htgToken,
									},
								}))
								// connectorApiSlice.utils.reset()
								replace("/")
							}}
						>
							HTG - Reduziert
						</div>
					)}
				</div>
			</ContentBody>
		</Page>
	)
}
